import { transition } from '@helpers/animate';
import { imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import brand, { BrandColours } from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { paragraphSmall } from '@helpers/typography';
import ButtonStyles from '@stories/Components/Buttons/Button/Button.styles';
import styled from 'styled-components';
const Container = styled.div `
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  color: ${brand.global.white};
  overflow: hidden;

  a& {
    text-decoration: none;

    ${() => Image}, svg {
      ${transition('transform', 0.25)};
    }

    &:focus-visible,
    &:hover {
      ${() => Image}, svg {
        transform: scale(1.05);
      }
    }
  }

  &[data-variant=${BrandColours.BlueDark}] {
    --contentColour: ${brand.primary.blue.dark};
    --imageColour: ${brand.primary.blue.light};

    &:has(${() => Image}) {
      --imageColour: ${brand.global.white};
    }

    &:has(${() => Image}) {
      border: 1px solid var(--contentColour);
    }
  }

  &[data-variant=${BrandColours.PurpleDark}] {
    --contentColour: ${brand.primary.purple.dark};
    --imageColour: ${brand.global.white};

    border: 1px solid var(--contentColour);
  }
`;
const ImageContainer = styled.div `
  ${imageWrapperPreserveRatio(328, 164)};

  display: grid;
  place-content: center;
  background-color: var(--imageColour);

  svg {
    width: 92px;
    aspect-ratio: 1;

    ${Container}[data-variant=${BrandColours.PurpleDark}] & {
      color: var(--contentColour);
    }
  }

  @media ${from(Device.Tablet)} {
    aspect-ratio: 259 / 146;
  }
`;
const Image = styled.img `
  --spacing: ${fluid(10, 16)};

  display: block;
  object-fit: contain;
  object-position: center;
  width: calc(100% - var(--spacing) * 2);
  height: calc(100% - var(--spacing) * 2);
  position: absolute;
  top: var(--spacing);
  left: var(--spacing);
`;
const ContentWrapper = styled.div `
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: var(--contentColour);
  padding: 16px;
  min-height: 157px;

  ${ButtonStyles.Container} {
    --buttonHeight: ${fluid(42, 56)};

    margin: auto 0 0 auto;
  }
`;
const Heading = styled.h3 `
  ${fonts.lato.semiBold};

  font-size: ${fluid(18, 22)};
  line-height: ${fluid(24, 34)};
  margin: 0 0 8px;
`;
const Subheading = styled.p `
  ${paragraphSmall};

  margin: 0 0 24px;
`;
const BrandCardStyles = {
    Container,
    ImageContainer,
    Image,
    ContentWrapper,
    Heading,
    Subheading,
};
export default BrandCardStyles;
